import {
  VIEWPORT_MODIFIED_EVENT,
  CANVAS_INITIALIZED_EVENT,
  LAYER_CHANGED_EVENT,
  RESTORED_FROM_HISTORY_EVENT,
  START_HISTORY_TRANSACTION_EVENT,
  END_HISTORY_TRANSACTION_EVENT,
} from "../constants/canvasConstants";
import type { Canvas, CanvasData, Object as FabricObject } from "../types/canvasTypes";
import { getDefaultViewportObject } from "./viewportHelpers";

export function triggerObjectModifiedEvent(canvas: Canvas) {
  canvas.fire("object:modified");
}
export function triggerViewportModified(canvas: Canvas) {
  canvas.fire(VIEWPORT_MODIFIED_EVENT);
}

export function triggerCanvasInitialized(canvas: Canvas) {
  canvas.fire(CANVAS_INITIALIZED_EVENT);
}

export function triggerObjectMoving(canvas: Canvas, object: FabricObject) {
  canvas.fire("object:moving", { target: object });
}

export function triggerLayerChanged(canvas: Canvas) {
  canvas.fire(LAYER_CHANGED_EVENT);
}

export function triggerHistoryRestoredFromHistory(canvas: Canvas) {
  canvas.fire(RESTORED_FROM_HISTORY_EVENT);
}

export function executeHistoryTransaction(canvas: Canvas, fn: () => void) {
  canvas.fire(START_HISTORY_TRANSACTION_EVENT);
  fn();
  canvas.fire(END_HISTORY_TRANSACTION_EVENT);
}

export async function executeAsyncHistoryTransaction(canvas: Canvas, fn: () => Promise<void>) {
  canvas.fire(START_HISTORY_TRANSACTION_EVENT);
  await fn();
  canvas.fire(END_HISTORY_TRANSACTION_EVENT);
}

export function isIgnoredEventOnInputTarget(event: Event) {
  const htmlElement = event.target as HTMLElement;

  return (
    isEditableInputElement(htmlElement) || isTextAreaElement(htmlElement) || htmlElement?.contentEditable === "true"
  );

  function isEditableInputElement(element: HTMLElement) {
    return element.tagName?.toLowerCase() === "input" && (element as HTMLInputElement).type !== "file";
  }

  function isTextAreaElement(element: HTMLElement) {
    return element.tagName?.toLowerCase() === "textarea";
  }
}

export const createEmptyCanvas = (width: number, height: number): CanvasData => {
  const viewport = getDefaultViewportObject(width, height);
  const newCanvas = {
    version: "5.3.0",
    objects: [viewport],
  };
  return newCanvas;
};
